import React, { useEffect, useState } from 'react';
import moment from 'moment';
import { Redirect, useHistory, useLocation } from 'react-router';
import axios from 'axios';

interface ITicketInboxContext {
    isLoading: boolean
    recordCount: number
    search: ISearch
    emails: ITicketInbox[]

    doSearch: (values: ISearch) => void
    changePage: (page: number) => void
    deleteEmail: (id: string) => Promise<void>
}

interface ITicketInbox {
    id: string
    date: moment.Moment
    senderName: string
    senderEmail: string
    subject: string
}

interface ISearch {
    pageNr: number
    pageSize: number
}

export let ticketInboxContext = React.createContext({} as ITicketInboxContext);

let { Provider } = ticketInboxContext;

let TicketInboxProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    let history = useHistory();
    let location = useLocation();

    let [isLoading, setLoading] = useState(true);
    let [emails, setEmails] = useState<ITicketInbox[]>([]);
    let [recordCount, setRecordCount] = useState(0);
    let [search, setSearch] = useState<ISearch>({
        pageNr: 0,
        pageSize: 20
    });

    useEffect(() => {
        if (location.state)
            processState(location.state);

    }, [location.state])


    if (!location.state)
        return <Redirect to={{ pathname: location.pathname, state: { search } }} />


    let processState = (state: any) => {
        if (state.search) {
            let request = {
                ...state.search
            };

            setSearch(request);
            getTicketEmails(request);
        }
    }

    let doSearch = (values: ISearch) => {
        let request = {
            ...values,
            pageNr: values.pageNr > 0 ? 0 : values.pageNr,
        }

        history.push(location.pathname, { search: request });
    }


    let getTicketEmails = async (search: ISearch) => {
        try {
            setLoading(true);
            let res = await axios.get('/api/TicketInbox/GetTicketEmails', { params: search });

            let { items, recordCount } = res.data;
            setEmails(items);
            setRecordCount(recordCount);

        } catch (err) { }
        finally {
            setLoading(false);
        }
    }

    let changePage = (page: number) => {
        let request = {
            ...search,
            pageNr: page
        }

        window.scrollTo(0, 0);
        history.push(location.pathname, { search: request });
    }

    let deleteEmail = async (id: string) => {
        if (window.confirm("Sicuro di voler eliminare questa email?") === false)
            return;

        try {
            await axios.delete(`/api/TicketInbox/DeleteEmail/${id}`);
            setEmails(emails.filter(x => x.id !== id));
            setRecordCount(recordCount - 1);
        } catch (err) { }
    }


    return (
        <Provider
            value={{
                isLoading,
                recordCount,
                search,
                emails,

                doSearch,
                changePage,
                deleteEmail
            }}
        >
            {children}
        </Provider>
    )
}

export default TicketInboxProvider;